import { render, staticRenderFns } from "./TableInspectMerge.vue?vue&type=template&id=f9cbc840&scoped=true&"
import script from "./TableInspectMerge.vue?vue&type=script&lang=js&"
export * from "./TableInspectMerge.vue?vue&type=script&lang=js&"
import style0 from "./TableInspectMerge.vue?vue&type=style&index=0&id=f9cbc840&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cbc840",
  null
  
)

export default component.exports